import { Modal, Button, Typography } from "@mui/material";
// import smileSuccess from '../../assets/smileSuccess 2.json';
// import Lottie from "react-lottie-player";
// import './CustomModal.css'
import { CSSProperties } from "react";
import './CustomModel.css'


interface ModalProps {
  open: boolean;
  onClose?: () => void;
  message: string;
  body: string;
  onPrimary: () => void;
  onSecondary: () => void;
  primaryBtnLabel: string;
  secondaryBtnLabel: string;
  hideSecondaryBtn:boolean;
  playAnimation: boolean;
  modalStyle?: React.CSSProperties; // Optional custom styling for the modal
  modalSize?: string;
  messageTypographyStyle?: CSSProperties; 
  bodyTypographyStyle?: CSSProperties; 
  buttonStyles?: CSSProperties; 
}

const CustomModal = ({
  open,
  onClose,
  message,
  body,
  onPrimary,
  onSecondary,
  primaryBtnLabel,
  secondaryBtnLabel,
  hideSecondaryBtn,
  // playAnimation,
  modalStyle,
  modalSize,
  messageTypographyStyle, 
  bodyTypographyStyle,
  buttonStyles
}: ModalProps) => {
  const modalSizeClass = `modal-size-${modalSize || 'medium'}`;
  return (
    <Modal open={open} onClose={onClose}>
     <div
        style={{
          margin: "auto",
          padding:'10px',
          backgroundColor: "white",
          ...modalStyle, 
        }}
        className={`modal-container ${modalSizeClass}`}
      > 
       {/* {playAnimation && ( 
          <Lottie
            loop
            animationData={smileSuccess}
            play
            speed={1}
            style={{width:'100px',height:'100px',marginLeft:'40%'}}
          />
        )} */}
        <Typography
            sx={{ ...messageTypographyStyle, text: '#101827', padding: '5px' }} 
            variant="h6"
        >
          {message}
        </Typography>
        <Typography
          sx={{ ...bodyTypographyStyle, text: '#101827', padding: '5px' }} // Apply typography styles
          variant="h6"
        >
          {body}
        </Typography>
        <div style={{...buttonStyles, padding:'10px'}}>
        {!hideSecondaryBtn && (
          <Button onClick={onSecondary} variant="text"  sx={{display:'flex !important',color:"black"}}>
            {secondaryBtnLabel}
          </Button>
          )}
          <Button onClick={onPrimary} className="button" sx={{display:'flex !important'}}>
            {primaryBtnLabel}
          </Button>
          
        </div>
      </div>
    </Modal>
  );
};

export default CustomModal;
